import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import {
    getRoom
} from '@evo/chat-core';
import { t } from 'c-3po';
import { Config } from '../../../../../../../../chat-prom-desktop/src/core/config';
import * as a from '../../../../../../libs/actions';
import { getSocketStore } from '../../../../../../libs/utils';

import { toJS } from '../../../../../helpers/ImmutableToJS';


import { Button } from '../../../../../ui/button';

// styles
import css from './banNotification.sss';


class ClientBanView extends React.Component {

    static propTypes = {
        companyBanned: PropTypes.bool,
        companyBannedSKK: PropTypes.bool,
        roomExtra: PropTypes.any,
    };

    handleGetCompanyInfo = () => {
        const { roomExtra } = this.props;
        roomExtra && this.props.send(a.EVENT_COMPANY_SHOW_INFO, { ident: roomExtra.company_id });
    }

    render() {
        const { companyBanned, companyBannedSKK } = this.props;
        const { CURRENT_DOMAIN, CORE_BANNED_SKK_NOTIFICATION } = Config.data.appState;
        let banMsg;
        if (companyBanned) {
            banMsg = (
                <React.Fragment>
                    <div className={css.text}>
                        {t`Продавец заблокирован`}
                    </div>
                    <Button
                        typeContour
                        dataQa='unban_btn'
                        onClick={this.handleGetCompanyInfo}
                    >
                        {t`Разблокировать`}
                    </Button>
                </React.Fragment>
            )
        }
        else if (companyBannedSKK && CORE_BANNED_SKK_NOTIFICATION) {
            banMsg = (
                <React.Fragment>
                    <div className={css.text}>
                        {t`Чат недоступен. Продавец находится на
                         проверке Службы контроля качества ${CURRENT_DOMAIN}`}
                    </div>
                </React.Fragment>
            )
        }
        else {
            banMsg = (
                <div className={css.text}>
                    {t`Вы были заблокированы продавцом.
                 Вы не можете отправлять ему сообщения.`}
                </div>
            );
        }

        return (
            <React.Fragment>
                {banMsg}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const companyBannedSKK = currentChatRoom.getIn(['extra', 'is_banned_skk']);

    return {
        roomExtra: currentChatRoom.get('extra'),
        companyBanned: currentChatRoom.get('companyBanned'),
        locale: state.get('locale'),
        companyBannedSKK,
    };
};

export const ClientBan = connect(mapStateToProps)(toJS(ClientBanView));

